import {CanActivateFn, Router, createUrlTreeFromSnapshot} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "./auth.service";

export const authGuard: CanActivateFn = async() => {
  const router = inject(Router);
  try {
    const isLogging = await inject(AuthService).isAuthenticated()
    if(!isLogging) {
      throw new Error('User not logged in')
    } 
    return isLogging
  } catch (error) {
    console.error("Guard error", error)
    router.navigateByUrl('/login')
    return false
  }
};
